import { handleAuthorization, handleOkResponseJson, handleBadRequest400 } from "./handlers"
import { obterToken } from "./loginService"
import * as axios from 'axios';

export default {
    obterPerfisAsync,
    enviarPerfilAsync,
    editarPerfilAsync,
	downloadLista
}

export const obterPerfisAsync = async () => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Perfil/obterLista`, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

export const enviarPerfilAsync = async (nome, descricao, idPermissao, aprovar, declinar, inativar, baixar) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ nome, descricao, idPermissao, aprovar, declinar, inativar, baixar })
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Perfil`, requestOptions)
        .then(handleAuthorization)
        .then(handleBadRequest400);
}

export const editarPerfilAsync = async (id, nome, descricao, ativo, idPermissao, aprovar, declinar, inativar, baixar) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ id, nome, descricao, ativo, idPermissao, aprovar, declinar, inativar, baixar })
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Perfil/atualizar`, requestOptions)
        .then(handleAuthorization)
        .then(handleBadRequest400);
}

export function downloadLista() {
	try {
		return axios({
			url: `${process.env.VUE_APP_ROOT_API}/Perfil/downloadPerfis`,
			method: 'GET',
			responseType: 'blob',
			headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
		}).catch(() => {
			return { status: false };
		})
			.then((response) => {
				if (response.status === false)
					return response;
				var fileURL = window.URL.createObjectURL(new Blob([response.data]));
				var fileLink = document.createElement('a');

				fileLink.href = fileURL;
				fileLink.setAttribute('download', 'perfis' + '.xlsx');
				document.body.appendChild(fileLink);

				fileLink.click();
			});
	} catch (e) {
		throw e;
	}
}